export default class WebmangoDBsContainer {
  constructor (id, { prefix, dbNames }, { DB, config } = {}) {
    if (!id) throw new Error('id missing')
    if (!DB) throw new Error('DB missing')
    if (!prefix) throw new Error('prefix missing')
    if (!dbNames) throw new Error('dbNames missing')
    this.id = id
    this.DB = DB
    this.prefix = prefix
    this.config = config
    this.dbs = new Map()
    this.addDB(...dbNames)
  }

  addDB (...dbNames) {
    dbNames.forEach(name => {
      if (this[name] != null) throw new Error(`Cannot add db with name ${name}, property already exists.`)
      const db = new this.DB(this.getDBName(name), this.config.db.options)
      this[`${name}DB`] = db
      this.dbs.set(name, db)
    })
  }

  async setup () {
    // ensures dbs are created and ready
    return this.info()
  }

  getDBName (name) {
    let root = ''
    if (process.browser) {
      root = `${process.env.NODE_ENV || 'development'}/`
    }
    return `${root}${this.DB.getID(this.prefix, this.id)}~${name}.db`
  }

  async withAll (fn) {
    return Promise.all(
      Object.values(this.dbs).map(fn)
    )
  }

  async info () {
    return this.withAll(db => db.info())
  }

  async compact () {
    return this.withAll(db => db.compact())
  }

  async destroy () {
    return this.withAll(db => db.destroy())
  }

  async erase () {
    return this.withAll(db => db.erase())
  }

  async clear () {
    await this.erase()
    await this.compact()
  }
}



// WEBPACK FOOTER //
// ../webmango-api/lib/db.js